module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "V4039_ebook-2.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "toc_marker-3"
    }
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("Also by Joseph Wambaugh")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Novels")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("The New Centurions")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("The Blue Knight")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("The Choirboys")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("The Black Marble")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("The Glitter Dome")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("The Delta Star")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("The Secrets of Harry Bright")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("The Golden Orange")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("Fugitive Nights")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("Finnegan’s Week")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("Floaters")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("Hollywood Station")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("Hollywood Crows")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("Hollywood Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("Hollywood Hills")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Nonfiction")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("The Onion Field")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("Lines and Shadows")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-3"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("Echoes in the Darkness")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("The Blooding: The True Story ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-3"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("of the Narborough Village Murders")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("Fire Lover: A True Story")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b056c306","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/V4039_ebook2.vue
// module id = 66
// module chunks = 0